export const ONBOARDING_STEP_COUNT = 2; // 4
